import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ExcludedUrlQueryParams from './ExcludedUrlQueryParams';

export type TagsInputValue = any[]

const mapStateToProps = (state: any, { t }: { t: any }) => {
  const excludedUrlQueryParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.url_query_parameter_to_exclude_from_url || [];
  const globalExcludedUrlQueryParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.url_query_parameter_to_exclude_from_url || []
  )
    .map(
      (element: any) => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalExcludedUrlQueryParams,
    ...excludedUrlQueryParams,
  ];

  return {
    globalAndAppTrackerSettings,
    appTrackerSettings: excludedUrlQueryParams,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(ExcludedUrlQueryParams));
